module.exports = __webpack_public_path__ + "static/media/fruit-cat.482cf302.JPG";